

var count = 0;

function remove_badges_banner() {
  const banners = document.querySelectorAll('.coll_product_banner');
  const imgs = document.querySelectorAll('.bss_pl_img');

  if (banners.length > 0 && imgs.length > 0) {

    banners.forEach(banner => {
      const insideImgs = banner.querySelectorAll('.bss_pl_img');
      insideImgs.forEach(img => img.remove());
    });

  } else {
    if (count < 100) {
      setTimeout(remove_badges_banner, 500);
      count++;
    }
  }
}

remove_badges_banner();